import styled from "styled-components";

export const Skill = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 0.4em;
  box-shadow: 0.3em 0.3em 0.7em #00000015;
  transition: border 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  border: rgb(250, 250, 250) 0.2em solid;
  padding: 2rem;
  cursor: pointer;

  &:hover {
    border: #006fff 0.2em solid;
  }
`;
